// Get the value of a specific parameter from the URL
function getURLParameter(parameterName) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(parameterName);
}

$(document).ready(function() {

  // Function to load products
  function loadProducts(collectionHandle) {

    var LANG = $('html').attr('lang');
    if(LANG == 'it'){
      var URL_AJAX = '/collections/' + collectionHandle + '/products.json';
    }else{
      var URL_AJAX = '/' + LANG + '/collections/' + collectionHandle + '/products.json';
    }

    $('#products-container').html('<div class="small-12 medium-4 columns"><div class="cstm-loading-box box"></div><div class="cstm-loading-box txt"></div></div><div class="small-12 medium-4 columns"><div class="cstm-loading-box box"></div><div class="cstm-loading-box txt"></div></div><div class="small-12 medium-4 columns"><div class="cstm-loading-box box"></div><div class="cstm-loading-box txt"></div></div>');
    // Make AJAX request to fetch products
    $.ajax({
      type: 'GET',
      url: URL_AJAX,
      dataType: 'json',
      success: function(data) {
        // Clear the existing content in the container
        $('#products-container').empty();

        if(data.products.length > 0){
          // Loop through the products
          for (var i = 0; i < data.products.length; i++) {
            var product = data.products[i];
            var firstImage = product.images[0].src;
            var secondImage = product.images[1].src;
            // Create HTML elements for each product
            var productHTML = '<div class="small-12 medium-4 columns">';
              productHTML += '<div class="product-collection-box">';
                if(LANG == 'it'){
                  productHTML += '<a href="/collections/' + collectionHandle + '/products/' + product.handle + '">';
                }else{
                  productHTML += '<a href="/' + LANG + '/collections/' + collectionHandle + '/products/' + product.handle + '">';
                }
                  productHTML += '<img src="' + firstImage + '" width="100%" height="auto" class="first" />';
                  productHTML += '<img src="' + secondImage + '" width="100%" height="auto" class="second" />';
                productHTML += '</a>';
                productHTML += '<span class="product-vendor">' + product.vendor + '</span>';
                productHTML += '<h4>' + product.title + '</h4>';
              productHTML += '</div>';
            productHTML += '</div>';
            
            // Append the product HTML to the container
            $('#products-container').append(productHTML);
          }
        }else{
          $('#collection-empty').clone().css({'display':'block'}).appendTo('#products-container');
        }
      },
      error: function(xhr, status, error) {
        console.log(error);
      }
    });
    $('.menu-collections li').removeClass('active');
    $('.menu-collections li[data-handle="' + collectionHandle + '"]').addClass('active');
    
  }

  var collectionHandle = getURLParameter('col');
  var colTitle = $('.menu-collections li[data-handle="' + collectionHandle + '"]').attr('data-title');
  $('.products-collection-container > h1').text(colTitle);
  loadProducts(collectionHandle);

  $('.menu-collections li a').click(function (e) {
    e.preventDefault();
    var colHandle = $(this).parent().attr('data-handle');
    var col_Title = $(this).parent().attr('data-title');
    $('.products-collection-container > h1').text(col_Title);
    loadProducts(colHandle);
  });
  
});


$(document).ready(function() {
  $('.footer .thb-widget-menu li a').each(function() {
    var originalText = $(this).text();
    var capitalizedText = originalText.charAt(0).toUpperCase() + originalText.slice(1);
    $(this).text(capitalizedText);
  });

  $('#privacy_policy_accept').click(function() {
    var currentValue = $('input[name="contact[tags]"]').val();
    
    if ($(this).is(':checked')) {
      var newValue = currentValue + ',privacy_policy_accepted';
    } else {
      var newValue = currentValue.replace(',privacy_policy_accepted', '');
    }
    
    // Update the value of the hidden input field
    $('input[name="contact[tags]"]').val(newValue);
  });

  setTimeout(function() {
    $('.globo-form-app .content').next('p').hide();
  }, 1500);

  
});